import React, { Component } from "react";
import ReactEcharts from "echarts-for-react";
import { TiInfoOutline } from "react-icons/ti";
import NoRecord from "app/Components/CommanComponents/NoRecord";

class EchartMultipleBarChart extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.seriesData !== this.props.seriesData) {
      // console.log("forceUpdate");
      this.forceUpdate();
    }
  }

  render() {
    let {
      category,
      seriesData,
      xAxis,
      yAxis,
      xAxisName,
      yAxisName,
      customToolTip,
      legendFlag,
    } = this.props;

    // console.log("seriesData", seriesData);
    let echartMultipleBar2Option = {
      tooltip: customToolTip
        ? customToolTip
        : {
          trigger: "axis",
        },
      yAxis: yAxis
        ? yAxis
        : {
          name: yAxisName ? yAxisName : "",
          nameLocation: "end",
          type: "value",
          min: 0, // minimum value to start
          minInterval: 1, // for integer axis value
          nameTextStyle: {
            fontWeight: "bold",
          },
        },
      xAxis: xAxis
        ? {
          ...xAxis,
          nameTextStyle: {
            color: "white",
          },
        }
        : {
          name: xAxisName ? xAxisName : "",
          nameLocation: "end",
          nameRotate: 90,
          nameTextStyle: {
            fontWeight: "bold",
            color: "white",
          },
          type: "category",
          data: category ? category : [],
        },
      legend:
        legendFlag == false
          ? false
          : {
            type: "scroll",
            // horizontalAlign: 'center',
            itemGap: 20,
            to: 100,
          },
      series: seriesData ? seriesData : [],
      dataZoom: [
        {
          start: 0,
          type: "inside",
        },
        {
          start: 0,
        },
      ],
    };

    if (this.props.isLegeng) {
      echartMultipleBar2Option.legend = this.props.isLegeng;
    }
    if (this.props.grid) {
      echartMultipleBar2Option.grid = this.props.grid;
    }
    let name =
      echartMultipleBar2Option.xAxis &&
        Object.keys(echartMultipleBar2Option.xAxis).length > 0 &&
        echartMultipleBar2Option.xAxis.name
        ? echartMultipleBar2Option.xAxis.name
        : null;

    // echartMultipleBar2Option = JSON.parse(JSON.stringify(echartMultipleBar2Option));
    // console.log("echartMultipleBar2Option", echartMultipleBar2Option);
    return (
      <React.Fragment>
        {
          Array.isArray(seriesData) && seriesData.length > 0 ? (
            <>
              <ReactEcharts
                style={{ height: this.props.height ? this.props.height : "270px" }}
                option={echartMultipleBar2Option}
              />
              <div className="text-center" style={{ marginTop: -30 }}>
                <span
                  className="font-weight-bold"
                  style={{ textTransform: "capitalize" }}
                >
                  {name}
                </span>
              </div>
            </>
          ) : (
            <NoRecord />
          )
          // <div className="noRecordFound"><TiInfoOutline /> No Records found...!</div>
        }
      </React.Fragment>
    );
  }
}

export default EchartMultipleBarChart;

// let PlannedAndActualCompletedWells = {
//     tooltip: {
//         trigger: 'axis',
//         axisPointer: {
//             type: 'shadow'
//         }
//     },
//     grid: {
//         top: '8%',
//         left: '3%',
//         right: '4%',
//         bottom: '3%',
//         containLabel: true
//     },
//     yAxis: {
//         type: 'value',
//         min: 0,
//         max: 500,
//         interval: 100,
//         axisLabel: {
//             formatter: '{value}',
//             color: '#333',
//             fontSize: 12,
//             fontStyle: 'normal',
//             fontWeight: 400
//         },
//         axisLine: {
//             show: false,
//             lineStyle: {
//                 color: '#ccc',
//                 width: 1
//             }
//         },
//         axisTick: {
//             show: false,
//             lineStyle: {
//                 color: '#ccc',
//                 width: 1
//             }
//         },
//         splitLine: {
//             lineStyle: {
//                 color: '#ddd',
//                 width: 1,
//                 opacity: 0.5
//             }
//         }
//     },
//     legend: {
//         horizontalAlign: 'center',
//         to: 100,
//     },

//     xAxis: {
//         type: 'category',
//         boundaryGap: true,
//         data: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"],
//         axisLabel: {
//             formatter: '{value}',
//             color: '#333',
//             fontSize: 12,
//             fontStyle: 'normal',
//             fontWeight: 400,

//         },
//         axisLine: {
//             show: false,
//             lineStyle: {
//                 color: '#ccc',
//                 width: 1
//             }
//         },
//         axisTick: {
//             show: false,
//             lineStyle: {
//                 color: '#ccc',
//                 width: 1
//             }
//         },
//         splitLine: {
//             show: false,
//             lineStyle: {
//                 color: '#ccc',
//                 width: 1
//             }
//         }
//     },
//     series: [{
//         color: '#5f6bc2',
//         name: 'Planned Wells',
//         type: 'bar',
//         barGap: 0,
//         label: {
//             normal: {
//                 show: false,
//                 position: 'insideBottom',
//                 distance: 5,
//                 align: 'left',
//                 verticalAlign: 'middle',
//                 rotate: 90,
//                 formatter: '{c}  {name|{a}}',
//                 fontSize: 14,
//                 fontWeight: 'bold',
//                 rich: {
//                     name: {
//                         color: '#fff',

//                     }
//                 }
//             }
//         },
//         data: [320, 332, 301, 334, 390, 350, 215]
//     },
//     {
//         color: '#28b873',
//         name: 'Actual Wells',
//         type: 'bar',
//         label: {
//             normal: {
//                 show: false,
//                 position: 'insideBottom',
//                 distance: 5,
//                 align: 'left',
//                 verticalAlign: 'middle',
//                 rotate: 90,
//                 formatter: '{c}  {name|{a}}',
//                 fontSize: 14,
//                 fontWeight: 'bold',
//                 rich: {
//                     name: {
//                         color: '#fff',

//                     }
//                 }
//             }
//         },
//         data: [220, 182, 191, 234, 290, 190, 115]
//     },

//     ]
// }
